import { render } from "./ParcProfileParcCard.vue?vue&type=template&id=0dfe5442"
import script from "./ParcProfileParcCard.vue?vue&type=script&lang=js"
export * from "./ParcProfileParcCard.vue?vue&type=script&lang=js"

import "./ParcProfileParcCard.vue?vue&type=style&index=0&id=0dfe5442&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__